module.exports = __webpack_public_path__ + "static/img/image_support_video_cover_06.b2ce79d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/support/image_support_video_cover_06.png
// module id = X411
// module chunks = 10